import {React}  from "react";
import { Button,Card,Form,Container,Row, Col, } from "react-bootstrap";
import {MensajeAlerta} from '../components/Messages/MensajeAlerta';
import { useFichaConsultante } from "hooks/useFichaConsultante";

function IngresarConsultante (){
  
  const { usuarioConsultante,setUsuarioConsultante,createUsuarioConsultante,respuestaServicio } = useFichaConsultante();

  const handleChange = event => {
    let valor=event.target.value;
    setUsuarioConsultante({ ...usuarioConsultante, [event.target.name]: valor });
  };

  
  return (
    <>
      <Container fluid>
      <Row>
          <Col md="8">
            <Card>
              <Card.Header>
                <Card.Title as="h4">Ingresar Consultante</Card.Title>
              </Card.Header>
              <Card.Body>
                <Form>
                  <Row>
                  <Col md="6">
                    <Form.Group>
                      <label>Rut</label>
                        <Form.Control
                          defaultValue={usuarioConsultante?.NumeroDocumento}
                          placeholder="1-9"
                          type="text"
                          name="NumeroDocumento"
                          onChange={handleChange}
                          
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                  <Col md="6">
                    <Form.Group>
                    <label>Nombre Social</label>
                        <Form.Control
                          defaultValue={usuarioConsultante?.NombreSocial}
                          placeholder="Como quiere ser llamado"
                          type="text"
                          name="NombreSocial"
                          onChange={handleChange}
                        ></Form.Control>
                        
                      </Form.Group>
                    </Col>
                   
                    <Col  md="6">
                      <Form.Group>
                        <label>Nombres</label>
                        <Form.Control
                          defaultValue={usuarioConsultante?.Nombres}
                          onChange={handleChange}
                          placeholder=""
                          type="text"
                          name="Nombres">
                        </Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  
                  <Row>
                    <Col md="6">
                      <Form.Group>
                        <label>Apellido Primario</label>
                        <Form.Control
                          defaultValue={usuarioConsultante?.ApellidoPrimario}
                          name="ApellidoPrimario"
                          onChange={handleChange}
                          type="text"
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md="6">
                      <Form.Group>
                        <label>Apellido Secundario</label>
                        <Form.Control
                          defaultValue={usuarioConsultante?.ApellidoSecundario}
                          name="ApellidoSecundario"
                          onChange={handleChange}
                          placeholder=""
                          type="text"
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  
                  <Row>
                    
                    <Col md="6">
                    <Form.Group>
                        <label>Correo</label>
                        <Form.Control
                          defaultValue={usuarioConsultante?.Correo}
                          //value={usuarioSistema.Correo}
                          placeholder=""
                          type="text"
                          name="Correo"
                          onChange={handleChange}
                        ></Form.Control>
                      </Form.Group>
                      
                    </Col>
                    <Col md="6">
                    <Form.Group controlId="Genero">
                        <label>Genero</label>
                        <Form.Control as="select"
                        defaultValue={usuarioConsultante?.Genero}
                        name="Genero"
                        onChange={handleChange}
                       
                        >
                          <option value="Femenino">Femenino</option>
                          <option value="Masculino">Masculino</option>
                          <option value="No binario">No binario</option>
                          <option value="Otro">Otro</option>
                          <option value="Prefiere no decir">Prefiere no decir</option>
                          
                        </Form.Control>
                      </Form.Group>
                      
                    </Col>
                  </Row>
                  
                  <Row>
                    <Col md="6">
                      <Form.Group>
                        <label>Teléfono</label>
                        <Form.Control
                          defaultValue={usuarioConsultante?.Telefono}
                          //value={usuarioSistema.Telefono}
                          placeholder="+56959..."
                          type="text"
                          name="Telefono"
                          onChange={handleChange}
                          
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col md="6">
                    <Form.Group controlId="fechaNacimiento">
                        <label>Fecha de Nacimiento</label>
                        <Form.Control
                          
                          defaultValue={usuarioConsultante?.FechaNacimiento}
                          //value={usuarioSistema.FechaNacimiento}
                          placeholder=""
                          type="date"
                          name="FechaNacimiento"
                          onChange={handleChange}
                          //onChange={(e) => setDate(e.target.value)}
                        ></Form.Control>
                      </Form.Group>
                      
                    </Col>
                  </Row>
                
                  <Row>
                    
                   
                  </Row>
                  
                  
                  <Button
                    className="btn-fill pull-right"
                    type="submit"
                    variant="info"
                    onClick={(e)=>{
                      e.preventDefault();
                      createUsuarioConsultante(usuarioConsultante);}}>
                  
                    Guardar
                  </Button>
                  <div className="clearfix"></div><br></br><br></br>
                  <MensajeAlerta mensajeTexto={respuestaServicio.mensajeTexto} estado={respuestaServicio.estado} />
                </Form>
              </Card.Body>
            </Card>
          </Col>
          
         
      </Row>
       
      </Container>
    </>
  );
  
}

export default IngresarConsultante;
